import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import history from './history';

import {store} from './store';
import AppContainer from './containers/AppContainer';

import registerServiceWorker, {unregister} from './registerServiceWorker';



ReactDOM.render(
    <Provider store={store}>
        <I18nextProvider i18n={ i18n }>
            <AppContainer history={history}/>
        </I18nextProvider>
    </Provider>
    , document.getElementById('root'));
//registerServiceWorker();
unregister();
